/* template */
<template><div :class="({'space-between':!fuzzy})" class="date-container"><template v-if="(fuzzy)"><mpx-image mode="widthFix" :src="(timeIcon)" class="time-icon"/><mpx-view @tap="onDateTap" class="time-text">{{spTimeText}}</mpx-view></template><template v-else><mpx-view v-for="(item, index) in (times)" :key="item.index" @tap="onDateTap" class="time"><span class="t">{{item.t}}</span><span class="w">{{item.w}}</span></mpx-view><div class="differ" v-if="(type === 'range' && differ)">{{differ}}天</div></template></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7b67e85a"}'>
.date-container
  height 54px
  box-sizing border-box
  @extend .flex-center
  position relative
  font-family 'PingFang SC'
  .time-icon
    width 15px
    margin-right 13px
    flex none
  .time-text
    font-family 'PingFang SC'
    font-weight 500
    color #333
    font-size 18px
    flex 1
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  &.space-between
    justify-content space-between
    border-bottom 0.5px solid #EEEEEE
  .differ
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    color #666
    font-size 13px
  .time
    font-size 18px
    color #333
    font-weight 500
    flex-grow 1
    text-align right
    &:first-child
      text-align left
    .w
      font-size 13px
      margin-left 4px
      font-weight 400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7b67e85a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./date-select.mpx.js?isComponent&outputPath=components%2Fdate-select7b67e85a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./date-select.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fdate-select7b67e85a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7b67e85a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/date-select7b67e85a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
